import React from 'react'

import {
    Lima,
    LimaLayouts,
    RemainingLayouts,
} from '../../collections/Lima/Lima'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from '../../collections/collections-props.routing'
import { FontScales } from '../../__styling/settings/fontScale'
import { LoadMore } from '../../collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreRouteProps } from '../../collections-new-loadmore/LoadMore/LoadMore'
import { CardOrientationOptions } from '../../cards/Portrait/Portrait'
import { FixedRatio, CardBreakpointRatios } from '@news-mono/web-common'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { TimestampType } from '../../content/CardTimestamp/CardTimestamp'
import { TeaserMode } from '../../cards/CardText/CardTeaser'
import { ResponsiveContainer } from '../../content/Picture/responsive'
import { KickerMode } from '../../cards/Kicker/Kicker'

export interface LimaRouteProps
    extends CollectionRouteProps,
        ResponsiveContainer,
        LoadMoreRouteProps {
    fixedRatios?: FixedRatio[] | CardBreakpointRatios
    teaserMode?: TeaserMode
    hideByline?: boolean
    kickerMode?: KickerMode
    timestamp?: TimestampType
    initialColumns?: number
    intermediateColumns?: number
    finalColumns?: number
    disableImageLazyLoad?: boolean
    hasBackground?: boolean
    fontScale?: FontScales
    isSponsoredCollection?: boolean
    cardOrientation?: CardOrientationOptions
    cardLayout?: LimaLayouts
    remainingCardLayout?: RemainingLayouts
    stretchSelf?: boolean
    hasSeparator?: boolean
    minimumNumberOfCards?: number
}

export const LimaRegistration = createRegisterableComponentWithData(
    'lima',
    ContentDataDefinitionLoader,
    (props: LimaRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={(loadMoreData) => {
                    return (
                        <Lima
                            items={
                                loadMoreData.loaded
                                    ? {
                                          loaded: true,
                                          result:
                                              loadMoreData.result.publications,
                                      }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs,
                            )}
                            sectionHeader={props.sectionHeader}
                            hideByline={props.hideByline}
                            kickerMode={props.kickerMode}
                            timestamp={props.timestamp}
                            teaserMode={props.teaserMode}
                            initialColumns={props.initialColumns}
                            intermediateColumns={props.intermediateColumns}
                            finalColumns={props.finalColumns}
                            verticalSpacing={props.verticalSpacing}
                            fixedRatios={props.fixedRatios}
                            disableImageLazyLoad={props.disableImageLazyLoad}
                            hasBackground={props.hasBackground}
                            hasSeparator={props.hasSeparator}
                            fontScale={props.fontScale}
                            onEvent={services.onEvent}
                            isSponsoredCollection={props.isSponsoredCollection}
                            cardOrientation={props.cardOrientation}
                            cardLayout={props.cardLayout}
                            remainingCardLayout={props.remainingCardLayout}
                            stretchSelf={props.stretchSelf}
                            minimumNumberOfCards={props.minimumNumberOfCards}
                            containerWidthRatios={props.containerWidthRatios}
                        />
                    )
                }}
            />
        )
    },
)
